import{_ as r}from"./_baseGetTag.js";import{i as t}from"./isObjectLike.js";var e=r,s=t;var a=function(r){return s(r)&&"[object Arguments]"==e(r)};export{a as _};
